module.exports = __webpack_public_path__ + "static/media/sexyawakening2.966c21d0.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/img/sexyawakening2.png
 ** module id = 293
 ** module chunks = 0
 **/